import React from 'react';

const PasswordReset = () => {
  // Password reset is now handled by the backend admin UI
  const apiBaseUrl = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/+$/, '');

  return (
    <div style={{ textAlign: 'center', marginTop: '20%' }}>
      <h1>Password Reset</h1>
      <p>
        Password reset is now handled by the backend admin system.
      </p>
      <p>
        Please visit the <a href={`${apiBaseUrl}/admin`}>Admin Dashboard</a> to reset your password.
      </p>
    </div>
  );
};

export default PasswordReset;